"use client"

import { useEffect } from "react"
import type { CompanionMode } from "./chat-context"

export function useChatHotkey(
  setCompanionMode: (m: CompanionMode) => void,
  currentMode: CompanionMode,
) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const isCmdK = (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k"
      if (!isCmdK) return

      const target = e.target as HTMLElement | null
      const tag = target?.tagName?.toLowerCase()
      if (tag === "input" || tag === "textarea" || target?.isContentEditable) return

      e.preventDefault()
      setCompanionMode(currentMode === "closed" ? "drawer" : "closed")
    }
    window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [setCompanionMode, currentMode])
}
